import Vue from 'vue';
import Router from 'vue-router';
// import store from '@/store'; // 引入 Vuex store
import MainContent from '@/views/CodeScan/MainContent';
import HomePage from '@/views/HomePage';
import GetStart from '@/views/CodeScan/GetStart';
import SubmitRequest from '@/views/CodeScan/SubmitRequest';
import LoopholeScan from '@/views/CodeScan/LoopholeScan';
import Settings from '@/views/Settings/settings';
import Notifications from '@/views/Notifications/notifications';
import Reports from '@/views/Reports/reports';
import ReportsView from '@/views/Reports/ReportsView';
import Checkout from '@/views/Reports/checkout';
import PaySuccessful from '@/views/Reports/paySuccessful';
import VulnerabilityInformation from '@/views/Reports/vulnerabilityInformation';
import PlayIng from '@/views/Reports/playing';
import MainView from '@/views/main-view';
import store from '@/store';
import EventBus from '@/lib/events';
import DocumentInfo from '@/views/Document';
import TermsOfService from '@/views/terms-of-service';
import PrivacyPolicy from '@/views/privacy-policy';
import VulDetail from '@/views/vul/vul-detail';
import Blog from '@/views/blog';
import FirstLogin from '@/views/first-login';
import ResetPassword from '@/views/reset-password';
import TokenManage from '@/views/TokenManage/token';
import TokenHistory from '@/views/TokenManage/token-history';
import Network from '@/views/network-setting';

Vue.use(Router);

const router = new Router({
  mode: 'history', // 使用 HTML5 历史模式，确保需要服务器端支持
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/report/task/:taskId/:shareId',
      name: 'VulDetail',
      component: VulDetail,
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
    },
    {
      path: '/',
      name: 'home-page',
      component: HomePage,
    },
    {
      path: '/request',
      name: 'Request',
      component: GetStart,
    },
    {
      path: '/terms',
      name: 'Terms',
      component: TermsOfService,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
    {
      path: '/submit-request',
      name: 'SubmitRequest',
      component: SubmitRequest,
    },
    {
      path: '/main',
      name: 'MainView',
      component: MainView,
      redirect: '/main/content',
      children: [
        {
          path: 'content',
          name: 'MainContent',
          component: MainContent,
        },
        {
          path: '/document',
          name: 'Document',
          component: DocumentInfo,
        },
        {
          path: 'assess',
          name: 'LoopholeScan',
          component: LoopholeScan,
        },
        {
          path: 'reports',
          name: 'ReportsIndex',
          component: Reports,
          meta: {
            title: 'reports',
            showFather: true,
          },
          // redirect: '/main-content',
          children: [
            {
              path: 'reports-view',
              name: 'ReportsView',
              component: ReportsView,
              meta: {
                title: 'Project List',
                showFather: false,
              },
            },
            {
              path: 'checkout',
              name: 'Checkout',
              component: Checkout,
            },
            {
              path: 'pay-successful',
              name: 'PaySuccessful',
              component: PaySuccessful,
            },
            {
              path: 'vulnerability-information',
              name: 'VulnerabilityInformation',
              component: VulnerabilityInformation,
            },
            {
              path: 'playing',
              name: 'PlayIng',
              component: PlayIng,
            },
          ],
        },
        {
          path: 'notification',
          name: 'Notification',
          component: Notifications,
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings,
        },
      ],
    },
    {
      path: '/setting',
      name: 'SettingMainView',
      component: MainView,
      children: [
        {
          path: 'first-login',
          name: 'FirstLogin',
          component: FirstLogin,
        },
        {
          path: 'reset-password',
          name: 'ResetPassword',
          component: ResetPassword,
        },
        {
          path: 'token',
          name: 'TokenManage',
          component: TokenManage,
        },
        {
          path: 'token-history',
          name: 'TokenHistory',
          component: TokenHistory,
        },
        {
          path: 'network',
          name: 'Network',
          component: Network,
        },
      ],
    },
    {
      path: '*',
      name: 'Index',
      component: HomePage,
    },
  ],
});

// 导航守卫
router.beforeEach((to, from, next) => {
  if (!store.getters['user/isAuthenticated']) {
    if (['MainContent', 'home-page', 'Terms', 'PrivacyPolicy', 'VulDetail'].includes(to.name)) {
      next();
    } else {
      if (['Blog'].includes(to.name)) {
        next('/');
      } else {
        EventBus.$emit('signIn');
        next('/');
      }
    }
  } else if (!store.getters['user/hasAccess']) {
    if (['MainContent', 'home-page', 'Request', 'SubmitRequest', 'Terms', 'PrivacyPolicy', 'VulDetail', 'Blog'].includes(to.name)) {
      next();
    } else {
      EventBus.$emit('noAccess');
      next(false);
    }
  } else if (store.getters['user/forceChangePwd']) {
    if (['FirstLogin', 'ResetPassword'].includes(to.name)) {
      // If navigating to FirstLogin or ResetPassword, allow it.
      next();
    } else {
      // If trying to navigate to any other page:
      if (['FirstLogin', 'ResetPassword'].includes(from.name)) {
        // If currently on FirstLogin or ResetPassword, cancel the navigation attempt.
        // This avoids the "Redirected" error for this common case.
        next(false);
      } else {
        // If not currently on FirstLogin/ResetPassword (e.g., initial load to a disallowed route,
        // or landed on another page somehow), redirect to FirstLogin.
        // This redirect is necessary and might still log a "Redirected" message, which is acceptable here.
        next({ name: 'FirstLogin' });
      }
    }
  } else {
    next();
  }
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
